<template>
  <div id="ztscps70">
    <div id="z1">
      <div>ZTS-cps70</div>
      <label>热敏打印机</label>
      <img :src="require('@/assets/pic/ztscps70/bg1icon.png')" />
    </div>
    <div id="z2">
      <label>ZTS-CPS70是一款云打印终端，外观时尚，配备高性能打印头，大容量纸仓设计，兼具语音播报功能，WIFI+4G双网通讯，海量订单一吐为快，适用于餐饮、零售等场景。</label>
    </div>
    <div id="z3">
      <div>声型兼具</div>
      <label>每笔收款悦耳动听，每张凭条清晰可见</label>
    </div>
    <div id="z4">
      <div>打印及时，拒绝漏单</div>
      <label>通过云平台进行消息推送，打印高效快捷</label>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'ZT-CPS70',
        data: [
          {label: _this.$t('lang.cpu'), desc: ['高性能32位安全处理器'],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['1MB RAM+8MB ROM'],pic: 'ram.png'},
          {label: '通讯方式', desc: ['WIFI / 4G / 4G+WIFI'], pic: 'comm.png'},
          {label: _this.$t('lang.speaker'), desc: ['4Ω-3W 频响范围：100Hz-20KHz≥90dB@50cm'], pic: 'speaker.png'},
          {label: _this.$t('lang.printer'), desc: [_this.$t('lang.in58mmhsprt'),'打印速度90mm/秒','支持外径80mm纸卷'], pic: 'prt.png'},
          {label: '切纸方式', desc: ['手动撕纸', '自动切纸（选配）'], pic: 'cutp.png'},
          {label: _this.$t('lang.button'), desc: ['电源开关×1，功能键×1，音量键×2'], pic: 'keyt.png'},
          {label: '指示灯', desc: ['3个指示灯'], pic: 'lamp.png'},
          {label: _this.$t('lang.port'), desc: ['电源×1、MicroUSB×1、RJ232×1'], pic: 'port.png'},
          {label: _this.$t('lang.adapter'), desc: ['输入: AC 100~240V','输出： DC 8.5V/3A'], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['125mm×125mm×115mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'},
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ztscps70 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/ztscps70/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.55rem;
  color: white;
}
#z1 div {
  margin-top: 3.1rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .12rem;
  margin-bottom: .44rem;
  font-size: .4rem;
}
#z1 img {
  width: 3.03rem;
}
#z2 {
  height: 1.78rem;
  background: #424242;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 10.8rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/ztscps70/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 11.28rem;
  color: #4D4D4D ;
}
#z3 div {
  margin: 3.12rem 0 .15rem 0;
  font-size: .65rem;
  font-weight: bold;
  color: white;
}
#z3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #F4F4F4;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/ztscps70/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.49rem;
  color: #4D4D4D;
}
#z4 div {
  margin: 3.4rem 0 .3rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: white;
}
#z4 label {
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #F4F4F4;
}
</style>
